import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BsCheck2, BsPlus } from 'react-icons/bs'
import { logEvent } from '@firebase/analytics'
import analytics from '../Utils/FirebaseAnalytics'
import { addMyTopic, removeMyTopic } from '../Stores/Actions'

/* "Prati" / "Pratim" toggle for an existing topic or category (topics.id). */
export default function FollowButton({ topicId }) {
  const dispatch = useDispatch()
  const items = useSelector((state) => state.myTopics?.items ?? [])
  const [busy, setBusy] = useState(false)

  if (!topicId) {
    return null
  }
  const followed = items.find((t) => t.topic_id === topicId)

  const toggle = async (event) => {
    event.stopPropagation()
    if (busy) return
    setBusy(true)
    if (followed) {
      await dispatch(removeMyTopic(followed.id))
      logEvent(analytics, 'w_topic_unfollowed')
    } else {
      await dispatch(addMyTopic({ topic_id: topicId }))
      logEvent(analytics, 'w_topic_followed')
    }
    setBusy(false)
  }

  return (
    <button
      type="button"
      className={`follow-button ${followed ? 'is-following' : ''}`}
      onClick={toggle}
      disabled={busy}
      aria-pressed={Boolean(followed)}
    >
      {followed ? <BsCheck2 /> : <BsPlus />}
      <span>{followed ? 'Pratim' : 'Prati'}</span>
    </button>
  )
}
